import { IsString, MaxLength } from 'class-validator';

export class WikiCategorySearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
